<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="middle-panel" @click.stop>
                <div class="dialog-title" v-t="'message.item_two_phase_method_setting_ga'">
                </div>
                <hr class="dialog-hr">
                <div class="dialog-body-small">
                    <div class="content-container">
                        <div class="qr-container">
                            <img :src="qrCodeUrl" alt="Google Authenticator QR Code"/>
                        </div>
                        <div class="input-container">
                            <div>
                                <input
                                    v-for="index in 6"
                                    :key="index"
                                    v-model="codes[index - 1]"
                                    maxlength="1"
                                    :ref="'code' + index"
                                    @input="handleInput(index, $event)"
                                    @paste="handlePaste($event, index)"
                                    @keydown.backspace="handleBackspace(index, $event)"
                                    class="code-input"
                                />
                            </div>
                            <div class="confirm-message">
                                <el-collapse-transition>
                                    <div v-if="errorInfo != null">
                                        <div class="confirm-error">{{ errorInfo }}</div>
                                    </div>
                                </el-collapse-transition>
                            </div>
                            <el-button type="primary" class="register-button" @click="clearConfirmCode" v-t="'message.button_reset'"></el-button>
                        </div>
                    </div>
                </div>
                <div class="dialog-body-small">
                    <span v-html="$t('message.info_two_phase_method_code_ga_warn1')"></span><br>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-button-field">
                    <el-button class="dialog-cancel-button" type="button" @click="$emit('cancel')" v-t="'message.button_back'"></el-button>
                </div>
            </div>
        </div>
    </transition>
</template>
    
<script>
import server from "../../../ServerApi.js";
import commonUtil from '../../../commonutil.js';
import constants from '../../../constants.js';
  
export default {
    props: {
        errorInfo: String
    },
    data() {
        return {
            qrCodeUrl: '',
            codes: ['', '', '', '', '', '']
        };
    },
    watch: {
        codes(confirmCodes) {
            if(confirmCodes.every(code => code !== '')) {
                this.checkCode();
            }
        }
    },
    mounted() {
      this.fetchQrCode();
    },
    methods: {
        fetchQrCode() {
            server.post('/publishtwophaseauthgaKey')
            .then((res) => {
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        this.qrCodeUrl = res.data.url;
                        break;
                    case constants.STATUS_ERROR_DENIED:
                        commonUtil.notifyMessage(this,"Error",commonUtil.getMessageText(this.$i18n,"error_two_phase_method_edit"));
                        this.$emit('cancel');
                        break;
                    default:
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "fetchQrCode").replace("{code}", res.data.status));
                        break;
                }
            })
            .catch((error) => {
                commonUtil.putExceptionErrorMessage(this, "fetchQrCode", error);
            })
        },
        checkCode() {
            const code = this.codes.join('');
            const request = {
                methodOption: constants.LOGIN_METHOD_GA,
                gaCode: code
            }
            this.$emit('verified', request);
        },
        handleInput(index, event) {
            this.$nextTick(() => {
                const key = event.target.value;
                const currentValue = this.codes[index - 1];
                const nextElement = this.$refs[`code${index + 1}`] ? this.$refs[`code${index + 1}`][0] : null;
                if (key >= '0' && key <= '9') {
                    if(currentValue !== '' && nextElement) {
                        nextElement.focus();
                    }
                }
            });
        },
        handleBackspace(index, event) {
            if (this.codes[index - 1] === '') {
                event.preventDefault();
                if (index > 1) {
                    const prevElement = this.$refs[`code${index - 1}`][0];
                    if(prevElement) {
                        prevElement.focus();
                    }
                }
            }
        },
        handlePaste(event, index) {
            const paste = (event.clipboardData || window.clipboardData).getData('text');
            if(paste) {
                const isNumeric = paste.split('').every(char => !isNaN(char) && char !== ' ');
                if (!isNumeric) {
                    event.preventDefault();
                    return;
                }
                const pasteArray = paste.split('');
                pasteArray.forEach((char, i) => {
                    if(index + i <= 6) {
                        this.$set(this.codes, index - 1 + i, char);
                    }
                });
                this.$nextTick(() => {
                    const nextElement = this.$refs[`code${index + pasteArray.length}`] ? this.$refs[`code${index + pasteArray.length}`][0] : null;
                    if(nextElement) {
                        nextElement.focus();
                    }
                });
            }
            event.preventDefault();
        },
        clearConfirmCode() {
            this.codes = ['', '', '', '', '', ''];
            this.$nextTick(() => {
                this.$refs.code1[0].focus();
            });
        }
    }
}

</script>

<style scoped>
button.input-pass-check {
    border-style: none;
    background-color: #fff;
    cursor: pointer;
    outline: none;
    position: absolute;
    height: 20px;
    width: 44px;
    left: 305px;
    top: 2px;
    z-index: 10;
    color: #848991;
    font-size: 10px;
}

.middle-panel {
    background: #fff;
    position: absolute;
    padding: 0;
    left: 50%;
    top: 50%;
    width: 580px;
    max-height: 80vh;
    margin-top: -40vh;
    margin-left: -250px;
    transition: all .3s ease;
    border-radius: 4px;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    overflow: hidden;
}

.content-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.qr-container {
    width: 202px;
    height: 202px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #f1f1f1;
}

.input-container {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.register-button {
    margin-top: 10px;
}

.code-input {
  box-sizing: border-box;
  width: 30px;
  height: 40px;
  margin: 0 5px;
  font-size: 20px;
  text-align: center;
  border: 2px solid #ccc;
  border-radius: 5px;
  transition: border-color 0.3s;
}

.code-input:focus {
  border-color: #007bff;
  outline: none;
}

.dialog-body-small {
    overflow: hidden;
}

.confirm-message {
    padding-top: 10px;
}

.confirm-error {
    padding-bottom: 15px;
    height: 35px;
    color: #d55169;
}

</style>